import {
  Button,
  Card,
  EButtonColorVariant,
  EHeadingStyleVariant,
  Heading,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import StartSlideImage from '@/assets/trips/claims-guide/start.jpeg';
import TrucksIcon from '@/assets/trips/claims-guide/trucks.svg';
import useWindowSize from '@/hooks/useWindowSize';

type TClaimsGuideCarouselStartSlideProps = {
  onStart: () => void;
};

export const ClaimsGuideCarouselStartSlide = ({ onStart }: TClaimsGuideCarouselStartSlideProps) => {
  const intl = useIntl();
  const windowSize = useWindowSize();

  return (
    <Card withBoxShadow={false}>
      <div
        style={{ height: `calc(${windowSize.height || 0}px - 5vh)` }}
        className="flex flex-col overflow-hidden md:!h-[800px] md:max-h-[80vh]">
        <Card.Media image={StartSlideImage.src} className="overflow-hidden grow">
          <div className="absolute p-8 bg-white top-[200px] left-4 right-4 rounded-2xl">
            <div className="flex justify-center">
              <TrucksIcon />
            </div>

            <Heading variant={EHeadingStyleVariant.H4} className="text-center">
              {intl.formatMessage(
                { defaultMessage: 'Avoid these {br} top 5 RV mishaps', id: 'M0gVF9' },
                { br: <br /> },
              )}
            </Heading>
          </div>

          <div className="absolute left-0 right-0 flex justify-center bottom-8">
            <Button
              label={intl.formatMessage({ defaultMessage: 'Start', id: 'mOFG3K' })}
              onClick={onStart}
              variant={EButtonColorVariant.Tertiary}
              onDark={true}
              tabIndex={-1}
            />
          </div>
        </Card.Media>
      </div>
    </Card>
  );
};
